var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user" },
    [
      _c(
        "el-dropdown",
        { attrs: { trigger: "click" } },
        [
          _c("div", { staticClass: "el-dropdown-link" }, [
            _vm._v("\n      Profile "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
            _vm._v(" "),
            _c("div", { staticClass: "user-info" }, [
              _c("div", { staticClass: "user-timezone" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.currentTimezone) + "\n        "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c(
                "el-dropdown-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { id: "profile-button", to: { name: "profile" } },
                    },
                    [_vm._v("\n          View Profile\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isAdmin
                ? _c(
                    "el-dropdown-item",
                    { attrs: { divided: "" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            id: "settings-button",
                            to: { name: "settings" },
                          },
                        },
                        [_vm._v("\n          Settings\n        ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-dropdown-item", { attrs: { divided: "" } }, [
                _c(
                  "a",
                  {
                    attrs: { id: "logout-button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.takeMeOut()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-circle-close-outline" }),
                    _vm._v(" Logout\n        "),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }